import { FilterQueryType } from "byzantine/src/dbbl/businessLogic/entities/paymentActivity";

export type SearchFilterState = {
  filters: FilterQueryType;
  searchValue: string;
  debouncedSearch: string;
  pageNumber: number;
};

type SearchFilterAction =
  | { type: "SET_FILTERS"; filters: FilterQueryType }
  | { type: "SET_SEARCH_VALUE"; searchValue: string }
  | { type: "SET_DEBOUNCED_SEARCH"; debouncedSearch: string }
  | { type: "RESET"; filters: FilterQueryType; searchValue: string }
  | { type: "SET_PAGE"; pageNumber: number };

const searchFilterReducer = (
  state: SearchFilterState,
  action: SearchFilterAction
): SearchFilterState => {
  switch (action.type) {
    case "SET_SEARCH_VALUE":
      return {
        ...state,
        searchValue: action.searchValue,
        pageNumber: 1,
      };
    case "SET_FILTERS":
      return {
        ...state,
        filters: action.filters,
        pageNumber: 1,
      };
    case "SET_DEBOUNCED_SEARCH":
      return {
        ...state,
        debouncedSearch: action.debouncedSearch,
      };
    case "RESET":
      return {
        filters: action.filters,
        searchValue: action.searchValue,
        debouncedSearch: action.searchValue,
        pageNumber: 1,
      };
    case "SET_PAGE":
      return {
        ...state,
        pageNumber: action.pageNumber,
      };
    default:
      return state;
  }
};

export default searchFilterReducer;
